import React from "react";
import PopupWrapper from "../../components/PopupWrapper";

const ChildSelectionPopup = ({
  isOpen,
  onClose,
  childList,
  title,
  onSelectChild,
}) => {

  if (!isOpen) return null;

  return (
    <PopupWrapper isOpen={isOpen} onClose={onClose} title={title} isSecondary={true}>
      <div className="centered-child-selection-container">
        <div>
          {childList && childList.map((child) => (
            <div key={child.ChildID} style={{ padding: 8, width: "100%" }}>
              <button
                className="kidNameButton"
                onClick={() => {
                  onSelectChild(child.ChildID);
                }}
              >
                {child.FirstName} <span className="ml-2">&#8594;</span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </PopupWrapper>
  );
};

export default ChildSelectionPopup;
